// extracted by mini-css-extract-plugin
export default {"root":"_3Bp_q_eT","logo":"_2QqorARP","caption":"_2EkrzwPA"};